import { useCallback, useEffect, useMemo, useState } from "react";
import { FormControlChildProps } from "../form-control";
import Select, { ActionMeta, MultiValue, OptionsOrGroups } from "react-select";
import { OnChangeValue } from "react-select";
import { LabelValue } from "@app/types";

export const optionAll = {
  label: "Tất cả",
  value: "",
};

interface CustomMultiReactSelect extends FormControlChildProps {
  placeholder?: string;

  className?: string;

  value?: MultiValue<LabelValue>;

  defaultValue?: MultiValue<LabelValue>;

  defaultStatus?: undefined | "valid" | "inValid" | "warn";

  errorClassName?: string;

  isSearchable?: boolean;

  options: OptionsOrGroups<LabelValue, any>;

  hasAll?: boolean;
}

function CustomMultiReactSelect({
  id,
  formik,
  placeholder,
  value = [],
  defaultValue = undefined,
  name,
  status,
  defaultStatus = undefined,
  errorClassName = "",
  className = "",
  isSearchable = true,
  options = [],
  hasAll = false,
}: CustomMultiReactSelect) {
  const [txValue, setTxValue] = useState(value);
  const [_status, changeStatus] = useState(status || defaultStatus);

  const handleChange = useCallback(
    (
      newValue: OnChangeValue<LabelValue, true>,
      actionMeta: ActionMeta<LabelValue>
    ) => {
      if (actionMeta.option?.value === "") {
        newValue = [optionAll];
      } else {
        newValue = newValue.filter((it) => it.value !== optionAll.value);
      }

      setTxValue(newValue);

      if (formik) {
        formik.setFieldValue(name!, newValue);
      }

      setTimeout(() => {
        if (formik) {
          formik.setFieldTouched(name!, true);
        }
      });
    },
    [formik, name]
  );

  useEffect(() => {
    if (value?.length) {
      setTxValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (defaultValue) {
      setTxValue(defaultValue);
    }
  }, [JSON.stringify(defaultValue)]);

  useEffect(() => {
    changeStatus(status || defaultStatus);
  }, [defaultStatus, status]);

  const isError = _status === "inValid" || _status === "warn";

  const optionsMemo = useMemo(() => {
    return hasAll ? [optionAll, ...options] : options;
  }, [hasAll, options]);

  return (
    <div>
      <div className={`w-full ${className}`}>
        <Select
          isMulti
          id={id}
          placeholder={placeholder}
          value={txValue}
          onChange={handleChange}
          isSearchable={isSearchable}
          options={optionsMemo}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: "#f4f5fa",
              height: "52px",
              borderColor: isError ? "#fc4040" : "",
            }),
          }}
        />
      </div>
      {isError && (
        <div className={`flex error-color text-xs ${errorClassName}`}>
          {formik &&
            formik.getFieldMeta(name!).error &&
            formik.getFieldMeta(name!).error}
        </div>
      )}
    </div>
  );
}

export default CustomMultiReactSelect;
